import {z} from 'zod'

import {CreateOrUpdateBlockButtonRowDocument} from '@sdox/api'

import {buttonSchema} from '../../utils/schema'
import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {buttonFormToInput, buttonFragmentToForm} from '../../utils/buttonMappers'

import type {BlockButtonInput, CreateOrUpdateBlockButtonRowMutation, XcNwBlock_ButtonTypeBlockRowType_Fragment} from '@sdox/api'

type UpdateButtonRowValidatorSchema = z.infer<typeof updateButtonRowValidatorSchema>

const updateButtonRowValidatorSchema = z.object({
  data: z.array(buttonSchema),
  meta: updateMetaSchema,
})

export const buttonRowConfig = createFormConfig<
  UpdateButtonRowValidatorSchema,
  CreateOrUpdateBlockButtonRowMutation,
  BlockButtonInput[],
  XcNwBlock_ButtonTypeBlockRowType_Fragment
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockButtonRowDocument,
  },
  fieldMapper: ({data}) => {
    if (!Array.isArray(data)) {
      throw new Error('field values must have a data array')
    }
    return data.map(buttonFormToInput) as BlockButtonInput[]
  },
  validatorSchema: updateButtonRowValidatorSchema,
  inputFields: [
    {
      inputType: 'array',
      fieldName: 'data',
      required: true,
      label: 'Button',
      fields: [
        {
          inputType: 'button',
          label: 'Button',
          required: true,
          fieldName: '',
          defaultValue: [],
          placeholder: '',
          description: '',
        },
      ],
    },
  ],
  getDefaultValues: (block) => ({
    data: block.items.map(buttonFragmentToForm),
    meta: {
      pullout: block.pullout,
      countryCodes: block.countryCodes,
    },
  }),
})
